(function ($) {
  var elementorHookRegistered = false;
  var widgetSelector = '[data-single-formation-banner]';

  function updateSeanceInfoCtas($scope) {
    $scope.find('[data-seance-info-cta]').each(function () {
      var $cta = $(this);
      var sessionTimestamp = parseInt($cta.attr('data-session-timestamp'), 10);
      var morningOfTimestamp = parseInt($cta.attr('data-morning-of-timestamp'), 10);
      var serverNow = parseInt($cta.attr('data-server-now'), 10);
      var registerLink = $cta.attr('data-register-link');
      var teamsLink = $cta.attr('data-teams-link');
      var registerLabel = $cta.attr('data-register-label');
      var liveLabel = $cta.attr('data-live-label');

      if (!sessionTimestamp || !morningOfTimestamp || !serverNow) {
        return;
      }

      if (!$cta.data('loaded-at')) {
        $cta.data('loaded-at', Date.now());
      }

      var now = serverNow + Math.floor((Date.now() - $cta.data('loaded-at')) / 1000);
      var twoHoursAfter = sessionTimestamp + 7200;

      if (now >= twoHoursAfter) {
        $cta.hide();
        return;
      }

      $cta.show();

      if (now >= morningOfTimestamp && now < twoHoursAfter && teamsLink) {
        $cta.attr('href', teamsLink);
        $cta.removeClass('btn-secondary').addClass('btn-accent');
        $cta.find('[data-seance-info-label]').text(liveLabel);
        return;
      }

      $cta.attr('href', registerLink);
      $cta.removeClass('btn-accent').addClass('btn-secondary');
      $cta.find('[data-seance-info-label]').text(registerLabel);
    });
  }

  function initSeanceInfoCtas($widget) {
    updateSeanceInfoCtas($widget);

    if ($widget.data('single-formation-banner-seance-timer')) {
      return;
    }

    $widget.data('single-formation-banner-seance-timer', window.setInterval(function () {
      updateSeanceInfoCtas($widget);
    }, 30000));
  }

  function initCohorteTabs($widget) {
    if ($widget.data('single-formation-banner-cohort-tabs-bound')) {
      return;
    }

    $widget.data('single-formation-banner-cohort-tabs-bound', true);

    $widget.on('click.singleFormationBannerCohorts', '[data-single-formation-banner-tab]', function () {
      var $tab = $(this);
      var target = $tab.data('single-formation-banner-tab');
      var $container = $tab.closest('.cohortes-container');

      $container.find('[data-single-formation-banner-tab]').removeClass('active');
      $container.find('.single-formation-banner__cohort-content').removeClass('active');

      $tab.addClass('active');
      $container.find('#' + target).addClass('active');
    });

    $widget.on('click.singleFormationBannerLegacyCohorts', '.cohortes-tabs .li-tabs', function () {
      var $tab = $(this);
      var target = $tab.data('tab');
      var $container = $tab.closest('.cohortes-container');

      if (!target) {
        return;
      }

      $container.find('.cohortes-tabs .li-tabs').removeClass('active');
      $container.find('.cohortes-content .tab-content').removeClass('active');

      $tab.addClass('active');
      $container.find('#' + target).addClass('active');
    });
  }

  function initHoraireTabs($widget) {
    $widget.find('.horaire-container').each(function () {
      var $container = $(this);
      var $tabs = $container.find('.tabs-horaires .tab');

      if (!$tabs.length) {
        $container.find('tr[data-horaire]').addClass('active');
        return;
      }

      if ($container.data('single-formation-banner-horaire-tabs-bound')) {
        return;
      }

      $container.data('single-formation-banner-horaire-tabs-bound', true);

      $container.on('click.singleFormationBannerHoraires', '.tabs-horaires .tab', function () {
        var $tab = $(this);
        var debut = $tab.data('horaire');

        $container.find('.tabs-horaires .tab').removeClass('active');
        $tab.addClass('active');

        $container.find('tr[data-horaire]').removeClass('active').filter(function () {
          return $(this).data('horaire') === debut;
        }).addClass('active');
      });

      $tabs.first().trigger('click');
    });
  }

  function getWidgets($scope) {
    if ($scope.is(widgetSelector)) {
      return $scope;
    }

    return $scope.find(widgetSelector);
  }

  function initSingleFormationBanner($scope) {
    getWidgets($scope).each(function () {
      var $widget = $(this);

      initSeanceInfoCtas($widget);
      initCohorteTabs($widget);
      initHoraireTabs($widget);
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/single-formation-banner.default',
      initSingleFormationBanner
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initSingleFormationBanner($(document));
  });
})(jQuery);
